import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Box, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Addcategory from "./Addcategory";
import EditCategory from "./EditCategory";
import { getAllCategory } from "../../../redux/features/assetManagementSlice";
import { Category_Table_Head } from "../../../components/datagrid/assetmanagement/CategoryTableHead";
import Deletecategory from "./DeleteCategory";
import SubCategories from "./Subcategories";

const Category = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { categoryData, loading } = useSelector(
    (state) => state.assetmanagement
  );
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
    category_status: 0,
    date: dayjs(value).format("YYYY-MM"),
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getAllCategory(data));
    }
  }, [pageNum, gridSize, value]);

  return (
    <GlobalWrapper
      title={"Categories"}
      actions={<Addcategory dispatchParams={data} />}
    >
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Category_Table_Head}
          rows={categoryData.data}
          meta={categoryData?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.category_name} />
              <GlobalAnchorList
                label=""
                component={
                  <EditCategory rowData={rowData} dispatchParams={data} />
                }
              />
              <GlobalAnchorList
                label="Sub Categories"
                component={
                  <SubCategories rowData={rowData} dispatchParams={data} />
                }
              />
              <GlobalAnchorList
                label=""
                component={
                  <Deletecategory
                    rowData={rowData}
                    data={data}
                    id={rowData?.category_id}
                  />
                }
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Category;
